module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card flex-row flex-wrap",
    class: [_vm.isCardList ? 'list' : ''],
    on: {
      "click": function($event) {
        return _vm.$emit('click')
      }
    }
  }, [_c('div', {
    staticClass: "card-header border-0"
  }, [_c('img', {
    attrs: {
      "src": _vm.courseProfileImage,
      "alt": "publisher-profile"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-block px-2"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.courseTitle))]), _vm._v(" "), _c('div', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm.courseOwnerName))]), _vm._v(" "), _c('div', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm.courseGrade) + " " + _vm._s(_vm.courseSubjectName))]), _vm._v(" "), _c('div', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm.isVideoCourse ? '강의수' : '참고서') + " " + _vm._s(_vm.courseLectureCount || 0))])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "card-action"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": ("/static/images/" + (_vm.subscriptionResources().icon))
    }
  }), _vm._v(" "), _c('span', {
    style: ({
      'color': _vm.subscriptionResources().color
    })
  }, [_vm._v("구독")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68df02a6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CourseCard.vue
// module id = 1584
// module chunks = 1